<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.bom_route_relation')" name="0">
        <InventBomRouteEdit @goBomRouteDiff="goBomRouteDiff"></InventBomRouteEdit>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.bom_route_check')" name="1">
        <InventBomRouteView ref="BomRouteView"></InventBomRouteView>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import InventBomRouteEdit from './InventBomRouteEdit.vue'
import InventBomRouteView from './InventBomRouteView.vue';
export default {
  components: {
    InventBomRouteEdit,
    InventBomRouteView
  },
  data() {
    return {
      tab_index: "0"
    }
  },
  methods: {
    goBomRouteDiff(t) {
      this.tab_index = "1";
      this.$refs.BomRouteView.dataAreaId = t.dataAreaId;
      this.$refs.BomRouteView.InventNum = t.ItemId;
    }
  }
}
</script>
